module.exports = __webpack_public_path__ + "img/register.b1ccd9c0.svg";